{
  "aiGeneratedAnswer": "Risposta generata dall'IA",
  "allCategories": "Tutte le categorie",
  "appliedFiltersToCurrentSearch": "Filtri applicati alla ricerca corrente",
  "apply": "Applica",
  "applyFilters": "Applica filtri",
  "autocompleteOptionsFound_many": "{{count}}{{label}} opzioni di completamento automatico trovate.",
  "autocompleteOptionsFound_one": "{{count}}{{label}} opzione di completamento automatico trovata.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} opzioni di completamento automatico trovate.",
  "autocompleteSuggestion": "suggerimento di completamento automatico: {{suggestion}}",
  "autocompleteSuggestionsFound_many": "{{count}} suggerimenti di completamento automatico trovati.",
  "autocompleteSuggestionsFound_one": "{{count}} suggerimento di completamento automatico trovato.",
  "autocompleteSuggestionsFound_other": "{{count}} suggerimenti di completamento automatico trovati.",
  "basedOnYourDevice": " (basato sul tuo dispositivo)",
  "basedOnYourInternetAddress": " (basato sul tuo indirizzo internet)",
  "categoriesText_one": "La seguente categoria ha prodotto risultati per – <strong>{{query}}</strong>",
  "categoriesText_other": "Le seguenti categorie hanno prodotto risultati per – <strong>{{query}}</strong>",
  "clearAll": "Cancella tutto",
  "clearMinAndMax": "Cancella min e max",
  "clearTheRangeToSelectOptions": "Cancella l'intervallo per selezionare le opzioni.",
  "clearTheSearchBar": "Cancella la barra di ricerca",
  "conductASearch": "Condurre una ricerca",
  "currentLocation": "Posizione attuale",
  "didYouMean": "Volevi dire <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Quando sono disponibili i risultati di completamento automatico, usa le frecce su e giù per rivedere e invio per selezionare.",
  "feedback": "Feedback",
  "filterGroupSearchInputLabel": "Cerca tra le opzioni di {{title}}",
  "invalidRange": "Gamma non valida",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Passare alla pagina dei risultati successivi",
  "navigateToThePreviousResultsPage": "Passare alla pagina dei risultati precedenti",
  "noAutocompleteOptionsFound": "0 opzioni di completamento automatico trovate.",
  "noAutocompleteSuggestionsFound": "0 suggerimenti di completamento automatico trovati.",
  "noResultsFoundIn": "Nessun risultato trovato in {{currentVerticalLabel}}.",
  "paginationPage": "pagina {{pageNumber}}",
  "pagination": "Paginazione",
  "readMoreAbout": "Leggi di più su <a>{{name}}</a>",
  "recentSearch": "ricerca recente: {{query}}",
  "recentSearchesFound_many": "{{count}} ricerche recenti trovate.",
  "recentSearchesFound_one": "{{count}} ricerca recente trovata.",
  "recentSearchesFound_other": "{{count}} ricerche recenti trovate.",
  "removeFilter": "Rimuovi il filtro «{{displayName}}»",
  "resultPreview": "anteprima dei risultati: {{value}}",
  "resultPreviewsFound_many": "{{count}} anteprime dei risultati trovate.",
  "resultPreviewsFound_one": "{{count}} anteprima del risultato trovata.",
  "resultPreviewsFound_other": "{{count}} anteprime dei risultati trovate.",
  "resultsCountText_many": "{{count}} risultati",
  "resultsCountText_one": "{{count}} risultato",
  "resultsCountText_other": "{{count}} risultati",
  "resultsCountWithPaginationText": "{{paginateStart}}–{{paginateEnd}} di {{resultsCount}} risultati",
  "searchHere": "Cerca qui…",
  "showingAllInstead": "Mostrando invece tutti i {{currentVerticalLabel}}.",
  "showLess": "Mostra meno",
  "showMore": "Mostra di più",
  "sources_many": "Fonti ({{count}})",
  "sources_one": "Fonte",
  "sources_other": "Fonti ({{count}})",
  "submitSearch": "Invia la ricerca",
  "suggestionResultsCount_many": "{{label}} – {{count}} risultati",
  "suggestionResultsCount_one": "{{label}} – {{count}} risultato",
  "suggestionResultsCount_other": "{{label}} – {{count}} risultati",
  "thankYouForYourFeedback": "Grazie per il tuo feedback!",
  "thisAnsweredMyQuestion": "Questa risposta ha risolto il mio dubbio",
  "thisDidNotAnswerMyQuestion": "Questa risposta non ha risolto il mio dubbio",
  "unselectAnOptionToEnterInARange": "Deseleziona un’opzione per inserire un intervallo.",
  "updateYourLocation": "Aggiorna la tua posizione",
  "useCurrentLocation": "Usa la posizione attuale",
  "useMyLocation": "Usa la mia posizione",
  "viewAll": "Visualizza tutto",
  "viewDetails": "Visualizza i dettagli"
}
